export const OrgUnit = function (data) {
  if (!data) data = {};
  this.name = data.name || null;
  this.locationCode = data.locationCode || null;
  this.latitude = data.latitude || null;
  this.longitude = data.longitude || null;
};
